import * as actionTypes from '../constants/actionTypes';

export function addToCart(dish) {
  return { type: actionTypes.CART_ADD_DISH, dish };
}

export function increaseCount(dish, maxCount) {
  return { type: actionTypes.CART_INCREASE_DISH_COUNT, dish, maxCount };
}

export function decreaseCount(dish, minCount = 0) {
  return { type: actionTypes.CART_DECREASE_DISH_COUNT, dish, minCount };
}

export function cleanCart() {
  return { type: actionTypes.CART_CLEAN };
}



// WEBPACK FOOTER //
// ./src/actions/cartActions.js